import { useState, useEffect, useRef } from 'react';
// Importa el archivo CSS (asegúrate de crear este archivo)
import styles from "../styles/animaEquipo.module.css"; // 🔥 Importa como módulo


export default function AnimaEquipo() {
    const containerRef = useRef(null);
    const [isVisible, setIsVisible] = useState(false);

    // Usamos las imágenes que ya tienes
    const imagenes = [
        { id: 1, alt: "Imagen 1", src: 'imgAni01', lado: "izquierda" },
        { id: 2, alt: "Imagen 2", src: 'imgAni02', lado: "izquierda" },
     
        { id: 4, alt: "Imagen 4", src: 'imgAni04', lado: "derecha" },
           { id: 3, alt: "Imagen 3", src: 'imgAni03', lado: "izquierda" },
        { id: 5, alt: "Imagen 5", src: 'imgAni05', lado: "derecha" },
        { id: 6, alt: "Imagen 6", src: 'imgAni06', lado: "derecha" }
    ];

    useEffect(() => {
        const observerOptions = {
            root: null,
            rootMargin: '0px',
            threshold: 0.1
        };

        const handleIntersect = (entries) => {
            entries.forEach((entry) => {
                if (entry.isIntersecting && !isVisible) {
                    console.log("Contenedor visible - activando animación");
                    setIsVisible(true);
                }
            });
        };

        const observer = new IntersectionObserver(handleIntersect, observerOptions);

        if (containerRef.current) {
            observer.observe(containerRef.current);
            console.log("Observer conectado al contenedor");
        }

        return () => {
            if (containerRef.current) {
                observer.unobserve(containerRef.current);
                console.log("Observer desconectado");
            }
        };
    }, [isVisible]);

    return (
        <section className={styles.bloqueAnimacion01}>
            {/* Contenedor de la imagen */}
           
        <div
            ref={containerRef}
            id="contenedorAnimacion01"
            className={styles.contenedorAnimacion01} 
        >
       
           
            
            <div className={styles.contenedorImagenesAni01}>
                {imagenes.map((imagen) => (
                    <div
                        key={imagen.id}
                        className={`
          ${styles.imagenItemAni01} 
          ${styles[`imagen-${imagen.lado}`]} 
          ${isVisible ? styles.visible : ''} 
          ${styles[`orden-${imagen.id}`]}
        `}
                    >
                        <img
                            src={`assets/${imagen.src}.png`}
                            alt={imagen.alt}
                            className={styles.imagenAni01}
                        />
                    </div>
                ))}
            </div>
        </div>

            </section>
    );
}